<div class="modal-header">
  <h4 class="modal-title">Change Gift Expiration Date</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="serverError !== null">
  <h2>Server error: {{ serverError }}</h2>
</div>

<div class="modal-body pb-0" *ngIf="serverError === null">

  <div class="alert alert-info" *ngIf="gift.status === GiftStatus.expired">
    The gift will no longer be expired after making this change.
  </div>

  <p>
    <b>
      Current expiration date:
      {{ dateStringFromISO8601(gift.expiration_date) }}
    </b>
  </p>

  <div class="form-group">
    <label for="newExpirationDate">
      New expiration date
    </label>
    <app-date-picker [id]="'newExpirationDate'"
                     [(content)]="newExpirationDate"></app-date-picker>
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
  <button type="button" class="btn btn-primary"
          [disabled]="!hasValidInput()"
          [class.disabled]="!hasValidInput()"
          *ngIf="!loading && !serverError"
          (click)="onSubmit()">
    Submit
  </button>
  <button type="button" class="btn btn-primary disabled" disabled
          *ngIf="loading">
    Loading...
  </button>
</div>
